import makeDefaultVerifiedProxyCount from "@/components/newcustomize/utils/makeDefaultVerifiedProxyCount";

export type TProxyPlanKey =
  | "shared_default"
  | "semidedicated_premium"
  | "dedicated_premium"
  | "shared_isp"
  | "semidedicated_isp"
  | "dedicated_isp"
  | "shared_residential"
  | "shared_verified";

export default function getProxyPlanKey({
  proxy_type,
  proxy_subtype,
  required_site_checks,
  proxy_count,
}: {
  proxy_type: string;
  proxy_subtype: string;
  required_site_checks?: string[];
  proxy_count?: number;
}): TProxyPlanKey {
  let proxyType = proxy_type === "free" ? "shared" : proxy_type;

  let proxySubtype =
    proxy_subtype === "non-premium" ? "default" : proxy_subtype;

  if (
    (proxy_type === "dedicated" || proxy_type === "semidedicated") &&
    (proxy_subtype === "default" || proxy_subtype === "non-premium")
  ) {
    proxySubtype = "premium";
  }

  if (required_site_checks?.length && proxySubtype === "datacenter_and_isp") {
    if (
      proxy_count &&
      proxy_count >= makeDefaultVerifiedProxyCount() &&
      proxyType === "shared"
    ) {
      proxySubtype = "verified";
    } else if (proxy_type === "dedicated" || proxy_type === "semidedicated") {
      proxySubtype = "isp";
    } else {
      proxySubtype = "default";
    }
  }

  return `${proxyType}_${proxySubtype}` as TProxyPlanKey;
}
